import { render } from "./NotSupportedVersionComponent.vue?vue&type=template&id=5912e68e&ts=true"
import script from "./NotSupportedVersionComponent.vue?vue&type=script&lang=ts"
export * from "./NotSupportedVersionComponent.vue?vue&type=script&lang=ts"

import "./NotSupportedVersionComponent.vue?vue&type=style&index=0&id=5912e68e&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__